import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

    tblName: any;

    ngOnInit() {
        this.test();
    }
    test() {
        if (JSON.parse(sessionStorage.getItem('consumerLogin'))) {
            const clicks = JSON.parse(sessionStorage.getItem('consumerLogin'));
            this.tblName = 'txnConsumerUsers';
        }
        else {
            if (JSON.parse(sessionStorage.getItem('subscriberLogin'))) {
                const clicks = JSON.parse(sessionStorage.getItem('subscriberLogin'));
                this.tblName = clicks.tableName;
            } else {
                const clicks = JSON.parse(sessionStorage.getItem('userLogin'));
                this.tblName = clicks.tableName;
            }
        }

    }

}
